<template>
  <div style="height: 100%;background-color: #fff" v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="bg-img">
      <div v-for="item in 10" :key="item" class="btn-list" @click="change"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fixedAssets',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    change () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 10000)
    }
  }
}
</script>

<style scoped>
.bg-img{
  width: 855px;
  height: 455px;
  background: url("../../assets/test.png")no-repeat;
  padding-top: 20px;
}
.btn-list{
  width: 200px;
  height: 70px;
  float: left;
  /*background: rgba(255, 123, 255, 0.2);*/
  margin-left: 50px;
  margin-bottom: 34px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/fixedAssets.vue